import { render, staticRenderFns } from "./search-region-orders.vue?vue&type=template&id=e5529bd8&scoped=true&"
import script from "./search-region-orders.js?vue&type=script&lang=js&"
export * from "./search-region-orders.js?vue&type=script&lang=js&"
import style0 from "./search-region-orders.scss?vue&type=style&index=0&id=e5529bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5529bd8",
  null
  
)

export default component.exports